/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { TransitionalManager } from 'app/shared/lib/transitional/manager';


@autoinject()
export class CalendarPage extends ComponentBase {

    ////****************** Fields and Properties **************************************////


    ////****************** Lifecycle events (in order of execution) ******************////
    constructor(
        private readonly transitional: TransitionalManager,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected attached(): void {
        const calendarPageId = '3113'; //hard coded to calendar pageID

        const f: HTMLFrameElement = <HTMLFrameElement><unknown>document.getElementById('calendarFrame');
        if(f.contentWindow) { this.transitional.openTransitional(f.contentWindow, calendarPageId, [], ''); }
    }


    ////****************** Aurelia Events *******************************************////


    ////****************** Functions ***********************************************////


}
